import { http } from '../../core/services'

const generateFailedTestCasesReport = sessionId =>
  http.get(
    `/reports/failed-test-cases/${sessionId}`,
    { responseType: 'blob' },
  )

export default generateFailedTestCasesReport
